import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MobileChatApiService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  sendTeacherMessage(payload: {
    student_id: number | string;
    message: string;
    message_by: 'teacher' | 'client' | 'student';
    feedback_taken?: boolean;
  }) {
    return this.http.post(`${this.apiUrl}teacher/send-message`, payload);
  }

  sendStudentMessage(payload: {
    session_id?: number | string | null;
    user_id: number | string;
    user_type: string;
    message: string;
    message_by: 'student' | 'teacher' | 'client';
    feedback_taken?: boolean;
  }) {
    return this.http.post(`${this.apiUrl}mobile-chat/send-message`, payload);
  }

  getChatHistoryByUserStudent(userId: number | string, studentId: number | string) {
    return this.http.get(`${this.apiUrl}mobile-chat/chat-history-by-user-student/${userId}/${studentId}`);
  }

  getAllChatHistoryByUserStudent(userId: number | string, studentId: number | string) {
    return this.http.get(`${this.apiUrl}mobile-chat/chat-all-history-by-user-student/${userId}/${studentId}`);
  }

  getNewMessages(sessionId: number | string, lastSequenceNo?: number) {
    return this.http.post(`${this.apiUrl}mobile-chat/new-messages`, {
      session_id: sessionId,
      last_sequence_no: lastSequenceNo ?? 0
    });
  }
}
